import { atom } from 'nanostores';
export const $crowdfundingDonationsWidget = atom(false);
